/* Nombra Studio — ficha de producto: selector de metal desplegable, tarjetas de cantidad y opiniones que rotan */
(function () {
  var DUO_PCT = 12;   // % de descuento al llevar 2 o más (descuento automático "Nombra - Dúo")
  var TRIO_PCT = 20;  // % de descuento al llevar 3 o más (descuento automático "Nombra - Trío")

  var SWATCHES = {
    'oro': 'linear-gradient(135deg,#f1dc9c,#c9a24a 55%,#a9803f)',
    'oro rosado': 'linear-gradient(135deg,#f7d9cf,#dca08f 55%,#c27f6e)',
    'plata': 'linear-gradient(135deg,#f3f4f6,#c3c7cd 55%,#9ea3ab)'
  };

  function money(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function init() {
    rotarOpiniones();
    iniciarTarjetas();
    iniciarMetal();
  }

  /* ---- Opiniones pequeñas que rotan ---- */
  function rotarOpiniones() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.sc-pd-mini__slot').forEach(function (slot, i) {
      var items = slot.querySelectorAll('.sc-pd-mini__item');
      if (items.length < 2 || reduce || slot.dataset.nbRot) return;
      slot.dataset.nbRot = '1';
      var idx = 0;
      setInterval(function () {
        items[idx].classList.remove('is-active');
        idx = (idx + 1) % items.length;
        items[idx].classList.add('is-active');
      }, 4200 + i * 400);
    });
  }

  /* ---- Metal y Letra: desplegables ---- */
  function iniciarMetal() {
    var CONF = { metal: { puntos: true }, letra: { puntos: false, clase: 'sc-letras' } };
    document.querySelectorAll('fieldset.product-form__input--pill').forEach(function (fs) {
      var leg = fs.querySelector('legend');
      if (!leg) return;
      var clave = leg.textContent.trim().toLowerCase();
      if (CONF[clave]) convertir(fs, clave, CONF[clave]);
    });
  }

  function convertir(fieldset, clave, conf) {
    var titulo = fieldset.querySelector('legend').textContent.trim();
    if (conf.puntos) {
      fieldset.querySelectorAll('label').forEach(function (label) {
        if (label.querySelector('.sc-color-dot')) return;
        var nombre = (label.textContent || '').replace('Variante agotada o no disponible', '').trim().toLowerCase();
        var fondo = SWATCHES[nombre];
        if (!fondo) return;
        var dot = document.createElement('span');
        dot.className = 'sc-color-dot';
        dot.style.background = fondo;
        dot.setAttribute('aria-hidden', 'true');
        label.insertBefore(dot, label.firstChild);
      });
    }

    var wrapper = fieldset.parentElement;
    var trigger;
    if (!wrapper || !wrapper.classList.contains('sc-color-dropdown')) {
      wrapper = document.createElement('div');
      wrapper.className = 'sc-color-dropdown' + (conf.clase ? ' sc-color-dropdown--' + clave : '');
      fieldset.parentNode.insertBefore(wrapper, fieldset);
      wrapper.appendChild(fieldset);
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'sc-color-trigger';
      trigger.innerHTML =
        '<span class="sc-color-trigger__dot" aria-hidden="true"></span>' +
        '<span class="sc-color-trigger__label"></span>' +
        '<svg class="sc-color-trigger__chevron" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 7l5 5 5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      wrapper.insertBefore(trigger, fieldset);
      fieldset.classList.add('sc-color-panel');
      if (conf.clase) fieldset.classList.add(conf.clase);
      trigger.addEventListener('click', function () { wrapper.classList.toggle('is-open'); });
      fieldset.addEventListener('click', function (e) {
        if (e.target.closest('label')) setTimeout(function () { sync(); wrapper.classList.remove('is-open'); }, 0);
      });
      document.addEventListener('click', function (e) { if (!wrapper.contains(e.target)) wrapper.classList.remove('is-open'); });
    } else {
      trigger = wrapper.querySelector('.sc-color-trigger');
    }

    function sync() {
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      var label = checked ? checked.nextElementSibling : null;
      var dot = label ? label.querySelector('.sc-color-dot') : null;
      var nombre = label ? (label.textContent || '').replace('Variante agotada o no disponible', '').trim() : titulo;
      trigger.querySelector('.sc-color-trigger__label').textContent = conf.puntos ? nombre : titulo + ': ' + nombre;
      var d = trigger.querySelector('.sc-color-trigger__dot');
      d.style.background = dot ? dot.style.background : '';
      d.hidden = !conf.puntos;
    }
    sync();
  }

  /* ---- Tarjetas de cantidad ---- */
  function iniciarTarjetas() {
    var wrap = document.querySelector('.sc-pd-tiers');
    if (!wrap) return;

    function qtyInput() { return document.querySelector('input.quantity__input[name="quantity"]'); }
    function activa() {
      var input = qtyInput();
      var valor = input ? String(parseInt(input.value, 10) || 1) : '1';
      wrap.querySelectorAll('.sc-pd-tier').forEach(function (card) {
        var on = card.getAttribute('data-unidades') === valor;
        card.classList.toggle('is-activa', on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    function elegir(n) {
      var input = qtyInput();
      if (!input) return;
      input.value = n;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      activa();
    }

    if (!wrap.dataset.nbClicks) {
      wrap.dataset.nbClicks = 'true';
      wrap.addEventListener('click', function (e) { var c = e.target.closest('.sc-pd-tier'); if (c) elegir(c.getAttribute('data-unidades')); });
      wrap.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var c = e.target.closest('.sc-pd-tier');
        if (c) { e.preventDefault(); elegir(c.getAttribute('data-unidades')); }
      });
      document.addEventListener('change', function (e) { if (e.target && e.target.matches && e.target.matches('input.quantity__input')) activa(); });
    }
    activa();

    function render(variant) {
      if (!variant || !variant.price) return;
      var base = variant.price;
      var precios = { '1': base, '2': Math.round(base * 2 * (1 - DUO_PCT / 100)), '3': Math.round(base * 3 * (1 - TRIO_PCT / 100)) };
      wrap.querySelectorAll('.sc-pd-tier').forEach(function (card) {
        var n = card.getAttribute('data-unidades');
        var p = precios[n];
        if (p == null) return;
        var pe = card.querySelector('.sc-pd-tier__precio'); if (pe) pe.textContent = money(p);
        var ue = card.querySelector('.sc-pd-tier__ud'); if (ue) ue.textContent = money(p / Number(n)) + '/ud.';
        var ae = card.querySelector('.sc-pd-tier__ahorro'); if (ae) ae.textContent = 'Ahorras ' + money(base * Number(n) - p);
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) { render(evt.data.variant); iniciarMetal(); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
